import { render, staticRenderFns } from "./registrar-periodo.vue?vue&type=template&id=7f16a79c"
import script from "./registrar-periodo.vue?vue&type=script&lang=js"
export * from "./registrar-periodo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports